import { ref, watch } from "vue";

/**
 * One-shot signal: resolves once the Library page has loaded and its anchors exist in the DOM.
 * Same shape as useProjectDashboardReadySignal.ts.
 */
const isReady = ref(false);

export function markLibraryReady(): void {
  isReady.value = true;
}

export function resetLibraryReady(): void {
  isReady.value = false;
}

export function waitForLibraryReady(): Promise<void> {
  if (isReady.value) return Promise.resolve();

  return new Promise<void>((resolve) => {
    const stop = watch(isReady, (ready) => {
      if (ready) {
        stop();
        resolve();
      }
    });
  });
}
